import request from '@/utils/request.js'
// 用户注册
export const registeredUser = data => {
  return request({
    method: 'POST',
    url: '/api/user/register',
    data
  })
}
// 发送短信验证码
export const sendSms = mobile => {
  return request({
    method: 'POST',
    url: '/api/sms/send',
    data: {
      mobile,
      event: 'register'
    }
  })
}
// 发送短信验证码
export const resetsendSms = mobile => {
  return request({
    method: 'POST',
    url: '/api/sms/send',
    data: {
      mobile,
      event: 'resetpwd'
    }
  })
}
// 用户注册
export const ResetUser = data => {
  return request({
    method: 'POST',
    url: '/api/user/resetpwd',
    data
  })
}
